import { observable, makeAutoObservable, action } from "mobx";
import { addAccount, authenticateUser, checkAuth, createSharedPost, deleteSharedAccount, fetchTeam, getShareServices, inviteToDesign, getSubscriptions, logout, registerUser, shareWithTeam } from "../services/AuthService";
import { deleteDesign, duplicateDesign, fetchEmbedDesign, fetchHTMLPreview, getAdminCategories, getDesignImage, getNFTUrl, mintNFT, updateDesignProperties } from "../services/DesignService";
import { fabric } from 'fabric'
import { checkIfImageExists, getRawImage } from "../services/ElementService";
import axios from "axios";
import { rotatePoint, scalePoint } from "../utils/transformations";

// User store
class AuthStore {
  @observable auth
  @observable id
  @observable name
  @observable email
  @observable picture
  @observable modalOpen
  @observable modalType
  @observable loading
  @observable globalErrors
  @observable errors
  @observable role
  @observable workAreaStore
  @observable nft

  constructor(workAreaStore, saveStore, errorStore) {
    // check if user already logged in, null object otherwise.
    const user = window.MM
      ? window.MM.user
      : { email: null, id: null, name: null, auth: null };
    makeAutoObservable(this)
    this.auth = user.id ? true : false
    this.id = user.id
    this.name = user.name
    this.email = user.email
    this.login = action.bound
    this.modalOpen = false
    this.errors = null
    this.globalErrors = null
    this.modalType = ''
    this.workAreaStore = workAreaStore
    this.saveStore = saveStore
    this.errorStore = errorStore
    this.role = {
      level: 0,
      name: ''
    }
    this.nft = {
      enabled: false,
      wallet_address: ''
    }
    
    window.login = this.login;
  }

  shareType = 'facebook'
  modals = {
    menuOpen: false,
    fileOpen: false,
    deletePrompt: false,
    shareOpen: false,
    shareModal: false,
    upgradeModal: false,
    projectsOpen: false,
    subscriptionModalOpen: false,
    adminModalOpen: false,
    loginOpen: false,
    nftOpen: false,
    publishOpen: false
  }
  nftMintLoading = false
  gifStatus = null
  largeGifWarning = null
  gifProgression = 0
  subscriptionPlans = {
    year: [],
    month: []
  }
  designMenuTab = null
  categoryList = []
  upgradeJSON = {
    'register': {
      heading: 'Please create a FREE account to unlock this feature',
      subheading: 'Registered users get access to more awesome features that help you take your creativity to another level!',
      featureHeading: `Here's what registers users get access to:`,
      features: [
        {
          text: 'Save your designs in the cloud',
          icon: '',
        },
        {
          text: 'Upload your own content',
          icon: '',
        },
        {
          text: 'Download your designs',
          icon: '',
        },
        {
          text: 'And much more...',
          icon: ''
        },
      ],
      cta: 'Sign up for FREE today!',
      image: '/modal-1.png',
      action: () => this.toggleAuthModal(true, 'register'),
      actionText: 'Sign Up'
    },
    'publish': {
      heading: 'Get a Mediamodifier PRO account and publish your designs to social media with a single click!',
      subheading: 'With a PRO account you will get access to many more features',
      featureHeading: `Here's what PRO users get access to:`,
      features: [
        {
          text: '7000+ easy-to-use design, mockup and video templates',
          icon: ''
        },
        {
          text: 'Publish your work directly to social media',
          icon: ''
        },
        {
          text: 'Download your designs as high-resolution images without watermarks',
          icon: ''
        },
        {
          text: 'And much more...',
          icon: ''
        }
      ],
      cta: 'Take the first step to becoming a PRO. You can cancel any time!',
      image: '/modal-2.png',
      action: () => this.toggleSubscriptionModal(true),
      actionText: 'View Plans'
    },
    'pro-template': {
      heading: 'Subscribe to Mediamodier PRO for Instant Access',
      subheading: 'Get access to premium templates',
      featureHeading: `Here's what PRO users get access to:`,
      features: [
        {
          text: '7000+ easy-to-use design, mockup and video templates',
          icon: ''
        },
        {
          text: 'Publish your work directly to social media',
          icon: ''
        },
        {
          text: 'Download your designs as high-resolution images without watermarks',
          icon: ''
        },
        {
          text: 'And much more...',
          icon: ''
        }
      ],
      cta: 'Take the first step to becoming a PRO. You can cancel any time!',
      image: null,
      action: () => this.toggleSubscriptionModal(true),
      actionText: 'View Plans'
    },
    'full-res-download': {
      heading: `Creating breath-taking designs is easy with the right tools. We've got your covered!`,
      subheading: 'Become a Design Master yourself! Download high-resolution designs today!',
      features: [
        {
          text: 'Download your designs as high-resolution images without watermarks',
          icon: ''
        },
        {
          text: '7000+ easy-to-use design, mockup and video templates',
          icon: ''
        },
        {
          text: 'Publish your work directly to social media',
          icon: ''
        },
        {
          text: 'And much more...',
          icon: ''
        }
      ],
      cta: 'Take the first step to becoming a PRO. You can cancel any time!',
      image: '/modal-3.png',
      action: () => this.toggleSubscriptionModal(true),
      actionText: 'View Plans'
    },
    'projects': {
      heading: `Organize your designs and save time with a PRO account`,
      subheading: 'Subscribe to save time and get access to more awesome features!',
      features: [
        {
          text: 'Organize your designs with the help of brands',
          icon: ''
        },
        {
          text: '7000+ easy-to-use design, mockup and video templates',
          icon: ''
        },
        {
          text: 'Download your designs as high-resolution images without watermarks',
          icon: ''
        },
        {
          text: 'And much more...',
          icon: ''
        }
      ],
      cta: 'Take the first step to becoming a PRO. You can cancel any time!',
      image: '/modal-4.png',
      action: () => this.toggleSubscriptionModal(true),
      actionText: 'View Plans'
    }

  }
  upgradeModalContent = null
  publishOpen = false
  teamDetails = {}
  teamSearch = []
  shareServices = null
  postURL = null
  selectedShare = []
  downloadLoading = false
  isGif = false
  subscription = false
  nftPreviewLoading = false
  nftPreview = null
  sharedWithTeam = false
  nftMinted = false
  embedDesign = null
  isTeam = false

  async mintNFT(name, description, supply = 1){
    try{
      this.nftMintLoading = true
      const link = `${window.location.origin}/design-editor/${this.workAreaStore.designId}/view`
      await mintNFT(name, description, this.nft.wallet_address, this.nftPreview, link, supply)
      this.nftMintLoading = false
      this.nftMinted = true
    }catch(err){
      this.nftMintLoading = false
      console.log(err)
    }
  }

  async fetchNFTImage(){
    try{
      this.nftPreviewLoading = true
      const { designId } = this.workAreaStore
      const data = await getNFTUrl(designId)
      const num = Math.random()
      if(data.url){
        this.nftPreview = data.url + `?v=${num}`
      }
      this.nftPreviewLoading = false
    }catch(err){
      console.log(err)
      this.nftPreviewLoading = false
    }
  }

  setNFTLoading(status){
    this.nftPreviewLoading = status
  }

  viewSubscriptions(){
    this.upgradeModalContent = null
    this.modals.upgradeModal = false
  }

  async fetchPricingData(){
    try{
      const { data } = await getSubscriptions()
      data.plans.forEach(plan => {
        this.subscriptionPlans[plan.name.toLowerCase()].push(plan)
      })
    }catch(err){
      console.log(err)
    }
  }

  openCustomResolutionTab(){
    this.toggleAnyModal('menuOpen', true)
    this.designMenuTab = 'custom'
  }

  toggleSubscriptionModal(status){
    this.modals.upgradeModal = false
    this.upgradeModalContent = null
    this.modals.subscriptionModalOpen = status
  }

  login(user) {
    if (user && user.id && user.email) {
      this.auth = true;
      this.id = user.id;
      this.name = user.name;
      this.role = user.role
      this.email = user.email;
      const windowObj = window.MM
      if(windowObj && !windowObj.user.email){
        window.MM.user = user
      }
    }
  }

  async logout() {
    await this.saveStore.saveDesign(true, true, this.role !== 1)
    await logout()
    this.auth = false;
    this.id = null;
    this.name = null;
    this.email = null;
    if(window.MM){
      window.MM.user = {
        email: null,
        name: null,
        id: null
      }
    }
  }

  async fetchEmbedDesign(){
    const data = await fetchEmbedDesign(this.workAreaStore.designId)
    this.embedDesign = data.html
  }

  toggleAnyModal(name, status){
    this.designMenuTab = null
    if(!this.workAreaStore.compiled){
      return
    }
    this.nftMinted = false
    if(name === 'nftOpen' && !status){
      this.nftPreview = null
    }
    Object.keys(this.modals).forEach(key => {
      if(key === name){
        this.modals[key] = status
      }else{
        this.modals[key] = false
      }
    })
  }

  async setDesignDeleted(){
    try{
      const { data } = await deleteDesign(this.workAreaStore.designId)
      if(data.deleted){
        const redir = `${window.location.origin}/profile/designs`
        window.location.replace(redir)
      }
    }catch(err){
      console.log(err)
      if(err.response.data.error){
        this.errorStore.setErrorMessage(err.response.data.message, true)
      }
    }
  }

  async duplicateDesign(){
    try{
      const { data } = await duplicateDesign(this.workAreaStore.pages, this.workAreaStore.title, this.workAreaStore.designId)
      if(data.duplicated){
        const url = `${window.location.origin}/design-editor/${data.duplicateId}`
        window.open(url, '_blank')
      }
    }catch(err){
      console.log(err)
      if(err.response.data.error){
        this.errorStore.setErrorMessage(err.response.data.message, true)
      }
    }
  }

  setSelectedShare(id, type){
    const service = this.shareServices[type].find(({ id: accountId }) => accountId === id)
    if(this.selectedShare && service && this.selectedShare.includes(service)){
      const idx = this.selectedShare.findIndex(s => s === service)
      this.selectedShare.splice(idx, 1)
    }else{
      this.selectedShare.push(service)
    }
  }

  async postContent(content){
    try{
      if(!this.selectedShare.length){
        return false
      }
      if(!content.length){
        return false
      }
      await Promise.all(this.selectedShare.map(async service => {
        const body = {
          account_id: service.id,
          content: content,
          serviceId: service.serviceId,
          type: service.type,
          designId: this.workAreaStore.designId
        }
        return await createSharedPost(body)
      }))
      this.errorStore.setErrorMessage('Post created', false)
      return true
    }catch(err){
      this.errorStore.setErrorMessage('Could not create post', true)
    }
  }

  async sendInvite(inviteMeta){
    try{
      const body = {
        inviteMeta,
        publicId: this.workAreaStore.designId
      }
      this.inviteLoading = true
      const { data } = await inviteToDesign(body)
      this.errorStore.setErrorMessage('Invited team member', false)
      return data
    }catch(err){
      console.log(err)
    }finally{
      this.inviteLoading = false
    }
  }

  async addNewAccount(type){
    try{
      this.shareType = type
      const { data } = await addAccount(this.shareType.toLowerCase(), this.workAreaStore.designId)
      this.errorStore.setErrorMessage('Account added', false)
      return data
    }catch(err){
      console.log(err)
    }
  }

  async removeAccount(accountId, type){
    try{
      const { serviceId } = this.shareServices[type].find(({ id }) => id === accountId)
      await deleteSharedAccount(serviceId, accountId)
      await this.populateShareServices()
      this.errorStore.setErrorMessage('Removed account', false)
    }catch(err){
      console.log(err)
    }
  }

  async populateShareServices(){
    try{
      const { data: { services: { services } } } = await getShareServices()
      const obj = {
        twitter: [],
        facebook: []
      }
      if(services.length === 0){
        this.shareServices = {
          facebook: [],
          twitter: []
        }
        return
      }
      await Promise.all(services.map(async service => {
        await Promise.all(service.accounts.map(async account => {
          account.serviceId = service._id
          const imgExists = await checkIfImageExists(account.profile_image_url)
          obj[service.service].push({...account, type: service.type, hasImage: imgExists})
        }))
      }))
      this.shareServices = obj
    }catch(err){
      console.log(err)
      console.log(err.response)
    }
  }

  async fetchTeam(){
    try{
      if(!this.auth){
        return
      }
      const { team, sharedWithTeam, activeTeamPlan } = await this.fetchTeamDetails(this.workAreaStore.designId)
      if(!team){
        this.isTeam = false
        this.activeTeamPlan = activeTeamPlan
        this.sharedWithTeam = sharedWithTeam
      }else{
        this.isTeam = true
        this.activeTeamPlan = activeTeamPlan
        this.sharedWithTeam = sharedWithTeam
        this.teamDetails = team
      }
    }catch(err){
      this.isTeam = false
    }
  }

  async shareWithTeam(status){
    try{
      this.sharedWithTeam = status
      const body = {
        publicId: this.workAreaStore.designId,
        status
      }
      await shareWithTeam(body)
    }catch(err){
      console.log(err)
      this.sharedWithTeam = !status
    }
  }

  async toggleShare(status, id = null){
    if(this.auth){
      this.toggleAnyModal('shareOpen', status)
      this.postURL = null
      this.selectedShare = null
      if(!this.teamDetails._id && this.isTeam){
        try{
          const { team, sharedWithTeam } = await this.fetchTeamDetails(id)
          if(!team){
            this.sharedWithTeam = sharedWithTeam
            this.isTeam = false
          }else{
            this.sharedWithTeam = sharedWithTeam
            this.isTeam = true
            this.teamDetails = team
          }
        }catch(err){
            this.sharedWithTeam = false
            this.isTeam = false
        }
      }
    }else{
      this.toggleUpgradeModal('register', true)
    }
  }

  togglePublish(status){
    this.fetchEmbedDesign()
    this.toggleAnyModal('publishOpen', status)
    const layers = this.workAreaStore.getAllLayers()
    this.isGif = !!layers.find(l => {
      const { photoType } = l
      const t = photoType ? photoType.toLowerCase() : null
      return t === 'gif' || t === 'sticker'
    })
  }

  async toggleShareModal(status){
    this.toggleAnyModal('shareModal', status)
    if(!this.shareServices){
      await this.populateShareServices()
    }
  }

  searchTeamMember(value){
    if(!this.isTeam){
      return
    }
    const roles = this.workAreaStore.designRoles
    const emails = roles.map(role => role.userId.email)
    const members = this.teamDetails.members.map(m => {
      const { email, name, firstname, lastname } = m.user
      if((email.includes(value) || name.includes(value)) && !emails.includes(email)){
        return {
          ...m.user,
          role: m.role
        }
      }
    }).filter(v => v)
    if(members.length === 0){
      members.push({
        none: true
      })
    }
    this.teamSearch = members
  }

  downloadBytes(bytes, type, name){        
    const url = window.URL.createObjectURL(new Blob([bytes], { type }))
    const l = document.createElement('a')
    l.href = url
    l.setAttribute('download', name)
    document.body.appendChild(l)
    l.click()
    l.remove()
  }

  calcRotate(layer){
    const P1 = {
      x: layer.xPos,
      y: layer.yPos
    }
    const Pr = {
      x: P1.x + layer.displayWidth / 2,
      y: P1.y + layer.displayHeight / 2
    }
    return rotatePoint(layer.rotation, Pr, P1);
  }

  async drawImage(ctx, images, y, canvasWidth, canvasHeight){
    await new Promise(async (resolve, reject) => {
      const img = new Image()
      const layer = images.shift()
      const { 
        xPos, yPos, displayWidth, displayHeight, filters,
        rotation, frameHeight, frameWidth
      } = layer
      const filter = layer.type === 'photo' ? `blur(${filters.blur / 10}px) opacity(${filters.opacity / 100}) contrast(${filters.contrast / 100}) brightness(${filters.brightness / 100}) saturate(${filters.saturation / 100})` : 'none'
      let data
      let crossOrigin = 'Anonymous'
      if(layer.type === 'photo' && !layer.photoType){
        data = layer.dataSource
      }
      if(layer.type === 'svgGroup'){
        data = layer.dataSource
      }
      if(layer.type === 'photo' && layer.photoType){
        let yIdx = y
        if(layer.frameData.frames.length - 1 < y){
          yIdx = layer.frameData.frames.length - 1
        }
        const frameData = layer.frameData.frames[yIdx]
        data = `data:image/png;base64,` + frameData.d
      }
      if(layer.type === 'element'){
        const { id: layerId } = layer
        const el = document.querySelector(`[data-id="${btoa(layerId)}"] svg`)
        if(el){
          const res = new XMLSerializer().serializeToString(el)
          const svg = res
            .replaceAll('width="100%"', `width="${Math.floor(displayWidth)}"`)
            .replaceAll('height="100%"', `height="${Math.floor(displayHeight)}"`)
          data = 'data:image/svg+xml,' + escape(svg)
        }
      }
      if(layer.type === 'text'){
        data = `data:image/png;base64,` + layer.snapshot
      }
      img.src = data
      img.crossOrigin = crossOrigin
      img.onload = () => {
        ctx.save()
        ctx.filter = filter
        if(rotation && layer.type === 'element'){
          const radians = rotation * Math.PI / 180
          ctx.translate(xPos, yPos)
          ctx.rotate(radians)
          ctx.drawImage(img, 0, 0)
        }else if(rotation && layer.type !== 'element'){
          const radians = rotation * Math.PI / 180
          const { x: px, y: py } = this.calcRotate(layer)
          ctx.translate(px, py)
          ctx.rotate(radians)
          ctx.drawImage(img, 0, 0, displayWidth, displayHeight)
        }else{
          ctx.drawImage(img, xPos, yPos, displayWidth, displayHeight)
        }
        ctx.restore()   
        if(images.length > 0){
          resolve(this.drawImage(ctx, images, y))
        }else{
          resolve(true)
        }
      }
      img.onerror = reject
    })
  }

  async setCanvasBackground(ctx, src, width, height) {
    return new Promise(resolve => {
      const img = new Image()
      img.src = src
      img.onload = async () => {
        ctx.drawImage(img, 0, 0, width, height)
        resolve(true)
      }
    })
  }

  getSelectedCategory(){
    const item = this.categoryList.find(({ selected }) => selected)
    return item
  }

  async getCategories(){
    try{
      const data = await getAdminCategories()
      this.categoryList = data.categoryList.map((listItem, idx) => {
        const { slug, name } = listItem
        return {
          value: slug,
          label: name,
          selected: idx === 0 ? true : false
        }
      })
    }catch(err){
      console.log(err)
    }
  }

  editSelectedCategoryValue(value, status){
    this.categoryList = this.categoryList.map(item => {
      if(item.value === value){
        item.selected = status
      }else{
        item.selected = false
      }
      return item
    })
  }

  async compileCanvasDesign(page, layerImages, maxFrames, fps, text, name, idx, pageLen, value){
    if(value !== 'gif'){
      return
    }
    const { 
      width, height, layers: lrs, 
      background, backgroundUrl, transparent, backgroundHeight, 
      backgroundPosition, backgroundId, filters,
      backgroundWidth, backgroundPosition: { x: bgX, y: bgY } 
    } = page
    let backgroundImg = null
    let backgroundColor = null
    if(backgroundUrl && !transparent){
      const bg = {
        filters,
        backgroundHeight,
        background,
        displayHeight: height,
        displayWidth: width,
        backgroundWidth,
        backgroundPosition,
        backgroundUrl,
        backgroundId
      }
      const res = await getRawImage(bg, true)
      backgroundImg = res.data.asset
    }
    if(!backgroundUrl && !transparent && background){
      backgroundColor = background
    }
    if(lrs.length === 0){
      return
    }
    //The image is static and should be downloaded by default
    if(typeof(layerImages[idx]) === 'string'){
      const bytes = this.base64ToArrayBuffer(layerImages[idx])
      this.downloadBytes(bytes, 'image/jpeg', `${name}.jpeg`)
      return
    }
    const add = pageLen > 1 ? 's' : ''
    let maxFramesPage = 0
    const lmap = await Promise.all(lrs.map(async l => {
      if(l.type === 'group'){
        return null
      }
      if(l.type === 'svgGroup'){
        try{
          const res = await getRawImage(l)
          return {
            ...l,
            dataSource: res.data.asset
          }
        }catch(err){
          console.log(err)
          return null
        }
      }
      if(l.type === 'photo' && l.photoType){
        let frameData
        layerImages.forEach(limg => {
          if(typeof(limg) !== 'string'){
            const found = limg.find(({ id }) => id === l.id)
            if(found){
              if(found.frames.length === maxFrames - 1){
                maxFramesPage = idx
              }
              frameData = found
            }
          }
        })
        return {
          ...l,
          frameData
        }
      }
      if(l.type === 'photo' && !l.photoType){
        if((l.displayHeight !== l.frameHeight || l.displayWidth !== l.frameWidth) || l.assetId){
          try{
            const res = await getRawImage(l)
            return {
              ...l,
              dataSource: res.data.asset
            }
          }catch(err){
            console.log(err)
            return null
          }
        }else{
          return {
            ...l
          }
        }
      }
      if(l.type === 'text'){
        const textEl = text.find(({ id }) => id === l.id)
        if(textEl){
          return {
            ...l,
            snapshot: textEl.snapshot
          }
        }
      }
      return {
        ...l
      }
    }))
    if(maxFramesPage === idx){
      this.gifStatus = `Drawing page${add}`
    }
    const layers = lmap.filter(l => l)
    let quality = 1
    if(maxFrames >= 30){
      quality = 3
    }
    if(maxFrames >= 40){
      quality = 4
    }
    if(maxFrames >= 60){
      quality = 5
    }
    const gif = new window.GIF({
      workers: 4,
      quality,
      width,
      height
    })
    if(window.gifRenderers){
      window.gifRenderers.push(gif)
    }else{
      window.gifRenderers = [gif]
    }
    let i = 0
    let y = 0
    for(i; i <= layerImages.length; i++){
      const iCopy = i
      if(iCopy === layerImages.length && y < maxFrames){
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        if(backgroundImg){
          await this.setCanvasBackground(ctx, backgroundImg, width, height)
        }
        if(!backgroundImg && backgroundColor){
          let bg = background
          if(!bg.includes('rgba')){
            bg = background.replace('rgb', 'rgba').replace(')', ', 1)')
          }
          if(bg.includes('#')){
            bg = this.workAreaStore.hexToRgba(background)
          }
          ctx.fillStyle = bg
          ctx.fillRect(0, 0, width, height)
        }
        const lrs = [...layers]
        i = 0
        await this.drawImage(ctx, lrs, y, width, height)
        gif.addFrame(ctx, { delay: fps * 10 })
        ctx.save()
        y += 1
      }
      continue
    }
    const p = idx + 1
    let prefix = 'st'
    if(p === 2){
      prefix = 'nd'
    }
    if(p === 3){
      prefix = 'rd'
    }
    if(p > 3){
      prefix = 'th'
    }
    gif.on('progress', progress => {
      this.gifStatus = `Rendering ${p}${prefix} page`
      const progression = progress * 100
      this.gifProgression = progression
    })
    return new Promise(resolve => {
      gif.on('finished', blob => {
        gif.freeWorkers.forEach(worker => worker.terminate())
        gif.abort()
        this.downloadBytes(blob, 'application/octet-stream', `${name}.gif`)
        this.gifStatus = `Downloading ${p}${prefix} page`
        this.gifProgression = 100
        resolve()
      })
      gif.render()
    })
  }

  resetProgression(){
    this.gifProgression = 0
    this.gifStatus = null
    this.largeGifWarning = null
  }

  async downloadImage({ value }){
    const { designId, title, pages } = this.workAreaStore
    this.downloadLoading = true
    try{
      const name = title.split(' ').join('-')
      if(value === 'gif'){
        this.gifStatus = 'Building your design'
        this.gifProgression = 1
      }
      const res = await getDesignImage(designId, value, true)
      const whiteList = ['png', 'jpg', 'jpeg', 'gif'] 
      const { width, height } = pages[0]
      const { images, maxFrames, gifFPS, text } = res.data
      if(value === 'gif'){
        const pageCopy = [...pages]
        if(pageCopy[0].width > 1300 || pageCopy[0].height > 1300 || maxFrames >= 100){
          this.largeGifWarning = 'Warning - Large design this might take a few minutes'
        }
        await Promise.all(pageCopy.map(async (page, idx) => (
          await this.compileCanvasDesign(page, images, maxFrames, gifFPS, text, `${name}${idx}`, idx, pages.length, value)
        )))
        this.downloadLoading = false
        this.resetProgression()
        return
      }
      res.data.images.map((image, idx) => {
        let bytes = image
        if(whiteList.includes(value)){
          bytes = this.base64ToArrayBuffer(image)
        }
        let type = `image/${value}`
        if(value === 'pdf'){
          const char = atob(image)
          const num = new Array(char.length)
          for(let i = 0; i < num.length; i++){
            num[i] = char.charCodeAt(i)
          }
          const arr = new Uint8Array(num)
          const blob = new Blob([arr], { type: 'application/pdf' })
          type = `application/${value}`
          this.downloadBytes(blob, type, `${name}${idx}.${value}`)
          this.downloadLoading = false
          return
        }
        if(value === 'svg'){
          const canv = document.createElement('canvas')
          const canvasId = `svg-render-${idx}`
          canv.id = canvasId
          canv.width = width
          canv.height = height
          canv.style.opacity = '0'
          canv.style.position = 'absolute'
          canv.style.zIndex = '-5'
          document.body.appendChild(canv)
          const canvas = new fabric.Canvas(canvasId)
          const imgURL = `data:image/jpeg;base64,${image}`
          new fabric.Image.fromURL(imgURL, (img) => {
            img.set({ left: 0, top: 0 })
            canvas.add(img)
            bytes = canvas.toSVG()
            canv.remove()
            type = `image/svg+xml`
            this.downloadBytes(bytes, type, `${name}${idx}.${value}`)
          })
          this.downloadLoading = false
          return
        }
        this.downloadBytes(bytes, type, `${name}${idx}.${value}`)
        this.downloadLoading = false
      })
    }catch(err){
      console.log(err)
      this.resetProgression()
      if(err.response && err.response.data && err.response.data.empty){
        this.errorStore.setErrorMessage('Design is empty', true)
      }else{
        console.log(err)
        this.errorStore.setErrorMessage('Failed to download design', true)
      }
      this.downloadLoading = false
    }
  }

  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  closeAll(){
    Object.keys(this.modals).forEach(key => {
      this.modals[key] = false
    })
  }
 
  toggleAuthModal(state, type = ''){
    this.modals.upgradeModal = false
    this.upgradeModalContent = null
    this.modalType = type
    this.errors = false
    this.modals.modalOpen = state
  }

  async editMemberRole(memberId, newValue){
    try{
      if(!this.isTeam){
        return
      }
      const roles = this.workAreaStore.designRoles
      const role = roles.find(({ userId }) => userId._id === memberId)
      const body = { teamId: this.teamDetails._id, newRole: newValue.value, memberId }
      const { data } = await updateDesignProperties(this.workAreaStore.designId, body)
      role.name = data.role.name
    }catch(err){
      console.log(err)
    }
    
  }

  clearErrors(){
    setTimeout(() => {
      this.errors = false
    }, 5000)
  }

  async handleLogin(username, password){
    try{
      if(this.auth){
        return
      }
      const res = await authenticateUser(username, password)
      const { status, user, subscription } = res.data
      if(status && user){
        this.auth = status
        this.id = user.id
        this.nft = user.nft
        this.name = user.name || user.firstname
        this.email = user.email
        this.subscription = user.subscription
        this.workAreaStore.populateBrands()
      }
      this.toggleAuthModal(false)
      await this.saveStore.saveDesign(true)
    }catch(err){
      this.errors = err.response.data.error.message
    }
  }

  toggleUpgradeModal(type, status, imgUrl = false, highImage = false){
    if(!this.workAreaStore.compiled){
      return
    }
    document.querySelector('.hidden-upload').style.display = 'none'
    if(status){
      this.modals.upgradeModal = true
      this.upgradeModalContent = this.upgradeJSON[type]
      let imgData = this.upgradeJSON[type].image
      if(!imgUrl && type === 'pro-template'){
        imgData = '/modal-1.png'
      }
      if(process.env.REACT_APP_NODE_ENV !== "development" && !imgUrl){
        if(!imgData.includes('design-editor')){
          imgData = `/design-editor` + imgData
        }
        this.upgradeModalContent.image = imgData
      }
      if(type === 'pro-template' && imgUrl){
        imgData = imgUrl
        this.upgradeModalContent.image = imgData
        this.upgradeModalContent.customImage = true
        this.upgradeModalContent.highImage = highImage
      }
    }else{
      this.upgradeModalContent = null
      this.modals.upgradeModal = false
    }
  }

  async handleRegister(data){
    try{
      const res = await registerUser(data)
      const { status, user, subscription } = res.data
      if(status && user){
        this.auth = status
        this.nft = user.nft
        this.id = user.id
        this.name = user.name || user.firstname
        this.email = user.email
        this.subscription = subscription
        this.role = user.role
      }
      this.toggleAuthModal(false)
    }catch(err){
      console.log(err.response.data)
      this.errors = err.response.data.message
    }
  }

  async handleLogout(){
    try{
      await this.saveStore.saveDesign(true, true, this.role !== 1)
      const res = await logout()
      if(res.data && res.data.status){
        this.id = null
        this.name = null
        this.email = null
        window.location.replace('http://mediamodifier.com')
      }
    }catch(err){
      console.log(err)
      this.globalErrors = err.response.data.error.message
    }
  }

  async checkAuthStatus(){
    try {
      const res = await checkAuth()
      const { data: { status, user, subscription } } = res
      this.auth = status
      this.nft = user && user.nft ? user.nft : null
      if(user){
        this.id = user._id
        this.name = user.name || user.firstname
        this.email = user.email
        this.role = user.role
        this.subscription = subscription
      }
    }catch(err){
      console.log(err)
      //this.globalErrors = err.response.data.error.message
    }
  }

  async updateRoles(role, memberId){
    try{
      const body = { teamId: this.teamDetails._id, newRole: role, memberId, title: this.workAreaStore.title }
      const { data } = await updateDesignProperties(this.workAreaStore.designId, body)
      const ids = this.workAreaStore.designRoles.map(r => r._id)
      if(!ids.includes(data.role._id)){
        this.workAreaStore.designRoles.push(data.role)
      }
    }catch(err){
      console.log(err)
    }
  }

  async fetchTeamDetails(designId){
    try{
      const res = await fetchTeam(designId)
      return res.data
    }catch(err){
      console.log(err)
      this.isTeam = false
      this.globalErrors = err.response.data.error.message
    }
  }

}

export default AuthStore;
